import { FC } from 'react';
import { useUser } from '@/hooks';
import InternalDashboard from './InternalDashboard';
import ExternalDashboard from './ExternalDashboard';

const Dashboard: FC = () => {
  const user = useUser();

  // Assuming 'internal' or 'admin' role for internal users.
  // Adjust this condition based on your exact role naming convention.
  if (user?.role === 'internal' || user?.role === 'admin') {
    return <InternalDashboard />;
  }

  // Default to External/Client dashboard
  return <ExternalDashboard />;
};

export default Dashboard;
